import { defaultDescription } from "./constants";
import { CsvDescription, Matrix } from "./types";
import { trim } from "./utils";

export class CsvChunkParser {

	private insideQuotedString = false;
	private line: string[] = [];
	private incompleteValue: string = '';
	private desc: CsvDescription;
	private prevChar: string;

	get incompleteLine() { return this.line }
	get eol() { return !this.line || this.line.length == 0 }

	constructor(desc?: Partial<CsvDescription>) {
		this.desc = Object.assign({}, defaultDescription, desc);
	}

	parseChunk(chunk: string) {
		const lines: Matrix<string> = [];
		let line = this.line;
		let value = this.incompleteValue;
		let char: string;
		let offset = 0;
		while (offset < chunk.length) {
			char = chunk.charAt(offset++);

			if (char === '\n' && !this.insideQuotedString) {
				line.push(value == this.desc.nullValue ? null : value);
				value = '';
				lines.push(line);
				line = [];
				continue;
			}

			if (char === '\r') continue;

			if (this.insideQuotedString) {
				if (this.prevChar === '\\') {
					if (char === 'n') {
						value += '\n';
					} else if (char === 'r') {
						value += '\r';
					} else if (char === 't') {
						value += '\t';
					} else if (char === '\\') {
						value += '\\';
						this.prevChar = '';
						continue;
					} else {
						value += char;
					}
				} else if (char === this.desc.quote) {
					value = trim(value, this.desc.quote);
					this.insideQuotedString = false;
				} else if (char != '\\') {
					value += char;
				}
			} else {
				if (char == this.desc.delimiter) {
					line.push(value == this.desc.nullValue ? null : value);
					value = '';
				} else if (value == '' && char == this.desc.quote) {
					this.insideQuotedString = true;
					value = '';
				} else {
					value += char;
				}
			}

			this.prevChar = char;
		}

		this.incompleteValue = value;
		this.line = line;
		return lines;
	}
}
